import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { settingsCurrentPlanPath } from '@/routes';

import ActivateAvaContent from '@/components/Billing/ActivateAvaContent';
import Modal from '@/components/Modal';

const propTypes = {
  show: PropTypes.bool
};

const defaultProps = {
  show: false
};

function AvaPaymentSuccessModal({ show }) {
  const navigate = useNavigate();

  const handleClose = () => navigate(settingsCurrentPlanPath());

  return (
    <Modal
      size='lg'
      show={show}
      bodyClassName='d-flex flex-column pt-3 pb-8 px-9 align-items-center text-center'
      backdrop='static'
      onHide={handleClose}
    >
      <ActivateAvaContent fromCheckout />
    </Modal>
  );
}

AvaPaymentSuccessModal.propTypes = propTypes;
AvaPaymentSuccessModal.defaultProps = defaultProps;

export default AvaPaymentSuccessModal;
